import { render, staticRenderFns } from "./carts.vue?vue&type=template&id=97071602&scoped=true&"
import script from "./carts.vue?vue&type=script&lang=js&"
export * from "./carts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97071602",
  null
  
)

export default component.exports